import { BookingStateRedux } from "./states";
import i18n from "../../config/i18n";
import { useSelector } from "react-redux";

function getBookingState(state, key: string) {
  const value = state.booking[key];
  return value;
}

const BookingGetters = {
  getIsEmbedded() {
    return useSelector((state) => getBookingState(state, "isEmbedded"));
  },
  getBookingOptions() {
    return useSelector(
      (state) => getBookingState(state, "homePageConfig") || {}
    );
  },
  getIsLoggedIn() {
    return useSelector((state) => !!getBookingState(state, "isLoggedIn"));
  },
  getCurrency() {
    return useSelector((state) => getBookingState(state, "currency"));
  },
  getBookingDetails(): BookingStateRedux["bookingInformation"] {
    return useSelector(
      (state) => getBookingState(state, "bookingInformation") || {}
    );
  },
  getRentalTerms() {
    return useSelector((state) => getBookingState(state, "rentalTerms"));
  },
  getAllAvailableLanguages() {
    return i18n.languages;
  },
  getSelectedLanguage() {
    return useSelector((state) => getBookingState(state, "selectedLanguage"));
  },
  getSessionExpiryTime() {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "sessionExpiryTime")
    );
  },
  getSelectedVehicleDetails(): BookingStateRedux["selectedVehicleDetails"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "selectedVehicleDetails")
    );
  },
  getUserDetails(): BookingStateRedux["userDetails"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "userDetails")
    );
  },
  getAppSettings(): BookingStateRedux["appSetting"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "appSetting")
    );
  },
  /* getTextResource(): BookingStateRedux["textresource"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "textresource")
    );
  },*/
  getCustomerPrimaryInfo(): BookingStateRedux["customerPrimaryDetails"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "customerPrimaryDetails")
    );
  },
  getAffiliateLocationDetails(): BookingStateRedux["affiliateLocationDetails"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "affiliateLocationDetails")
    );
  },
  getTextResourceDetailsBasedOnLang(): BookingStateRedux["textResourceBasedOnLang"] {
    return useSelector((state: BookingStateRedux) =>
      getBookingState(state, "textResourceBasedOnLang")
    );
  },
  getBranchMapSearch(): {
    branchSearchAddress: string;
    branchAddressCoords: { lat: number; lng: number } | null;
    branchDistanceMap: Record<string, number>;
    branchMapPanelState: 1 | 2 | 3;
    branchSelectedLocationCode: string | null;
    dropoffSearchAddress: string;
    dropoffAddressCoords: { lat: number; lng: number } | null;
    dropoffDistanceMap: Record<string, number>;
    dropoffMapPanelState: 1 | 2 | 3;
    dropoffSelectedLocationCode: string | null;
  } {
    return useSelector((state: BookingStateRedux) => {
      const info = getBookingState(state, "bookingInformation");
      return {
        branchSearchAddress: info?.branchSearchAddress ?? "",
        branchAddressCoords: info?.branchAddressCoords ?? null,
        branchDistanceMap: info?.branchDistanceMap ?? {},
        branchMapPanelState: info?.branchMapPanelState ?? 1,
        branchSelectedLocationCode: info?.branchSelectedLocationCode ?? null,
        dropoffSearchAddress: info?.dropoffSearchAddress ?? "",
        dropoffAddressCoords: info?.dropoffAddressCoords ?? null,
        dropoffDistanceMap: info?.dropoffDistanceMap ?? {},
        dropoffMapPanelState: info?.dropoffMapPanelState ?? 1,
        dropoffSelectedLocationCode: info?.dropoffSelectedLocationCode ?? null,
      };
    });
  },
};
export { BookingGetters as default, BookingGetters };
